import React, { useState, useEffect } from 'react';
import { useGetcustomerMutation, useGetCustomerDetailsMutation } from "../../../../../store/api/customer_api";
// import Input from '../../../../Core/Fields/Floating/Input';
// import Date from '../../../../Core/Fields/Floating/Date';
// import SelectSearch from '../../../../Core/Fields/Floating/SelectSearch';
// import CollapsibleSection from '../../../../Core/CollapsibleSection/CollapsibleSection';
import VersionHistory from '../../../../../utils/VersionHistory';
import Input from '../../../../../Core/Fields/Floating/Input';
import Date from '../../../../../Core/Fields/Floating/Date';
import SelectSearch from '../../../../../Core/Fields/Floating/SelectSearch';
import CollapsibleSection from '../../../../../Core/CollapsibleSection/CollapsibleSection';
import GetIcon from '../../../../../utils/Icon';

function Tab1({genaralData, setTab1Data, setTab1CustomerData, orderNo, fieldErrors, activityboll, customer, tab1Data, po_status, pTerms, price, currency, taxandchanges, project, cost_center,termandcondition }) {
    const [showActivity, setShowActivity] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [getCustomer, { data: getitem_list_data }] = useGetcustomerMutation();
    const [selectedCustomer, setSelectedCustomer] = useState('');
    const [getCustomerDetails] = useGetCustomerDetailsMutation();

    console.log(genaralData?.payment_terms_template, "tab1Data_came_40");

    const billingTypeList = [
        { name: 'Tax Invoice' },
        { name: 'Retail' }
    ]

    const orderTypeList = [
        { name: 'Maintenance' },
        { name: 'Sales' },
        { name: 'Shopping Cart' }
    ]
    console.log(billingTypeList, "billingTypeList");

    const [fields, setFields] = useState({
        orderNo: orderNo || '',
        date: '',
        customer: '',
        dueDate: '',
        order_type: '',
        billingType: '',
    });

    useEffect(() => {
        // Call once on page load with empty search
        getCustomer({ search_input: '' });
    }, []);

    useEffect(() => {
        // Skip if empty — already called on page load
        if (searchTerm) {
            const body = { search_input: searchTerm };
            getCustomer(body);
        }
    }, [searchTerm]);

    const customerOptions = getitem_list_data?.result?.customers || [];
    console.log(customerOptions, "customerOptions");
    useEffect(() => {
        if (customer) {
            setSelectedCustomer(customer);
            handleChange('customer', customer);

            // Fetch customer details if customer is provided
            const fetchCustomerDetails = async () => {
                try {
                    const response = await getCustomerDetails({ customer_name: customer });
                    if (response?.data) {
                        setTab1CustomerData(prev => ({
                            ...prev,
                            customerDetails: response.data
                        }));
                    }
                } catch (error) {
                    console.error("Failed to fetch customer details:", error);
                }
            };
            fetchCustomerDetails();
        }
    }, [customer]);

    useEffect(() => {
        const fetchDetails = async () => {
            if (selectedCustomer) {
                try {
                    const response = await getCustomerDetails({ customer_name: selectedCustomer });
                    if (response?.data) {
                        setTab1CustomerData(prev => ({
                            ...prev,
                            customerDetails: response.data
                        }));
                    }
                } catch (error) {
                    console.error("Failed to fetch customer details:", error);
                }
            }
        };
        fetchDetails();
    }, [selectedCustomer]);

    const handleChange = (field, value) => {
        console.log(field, value, "check_val");

        setTab1Data({ ...tab1Data, [field]: value });
    };

    return (
			<div
				className="row sidebarbox m-0 p-2"
				style={{
					borderRadius: "5px",
					maxHeight: "80vh",
					height: "74vh",
					overflowY: "scroll",
					flexWrap: "nowrap",
					display: "flex",
					flexDirection: "column",
				}}
			>
				{" "}
				<div>
					<div className="d-flex " style={{ marginBottom: "7px", gap: "10px" }}>
						<div className="col">
							<Input
								id="orderNo"
								label="Order No"
								value={tab1Data.orderNo}
								onChange={(e) => handleChange("orderNo", e.target.value)}
								readOnly={true}
								className={fieldErrors.orderNo ? "errorborder" : ""}
								style={{ height: "30px" }}
							/>
						</div>
						<div className="col">
							{po_status === "" ? (
								<Input
									id="date"
									label="Order Date"
									value={tab1Data.date.split(" ")[0]}
									readOnly
									className={fieldErrors.date ? "errorborder" : ""}
									style={{ height: "30px" }}
								/>
							) : (
								<Date
									id="date"
									label="Order Date"
									value={tab1Data.date}
									onChange={(e) => handleChange("date", e.target.value)}
									className={fieldErrors.date ? "errorborder" : ""}
									style={{ height: "30px" }}
								/>
							)}
						</div>
					</div>

					<div className="col-12" style={{ marginBottom: "12px" }}>
						{ po_status ? (
							<Input
								id="Select Customer"
								label="Select Customer"
								value={tab1Data.customer}
								readOnly={true}
								className={fieldErrors.customer ? "errorborder" : ""}
								style={{ height: "30px" }}
							/>
						) : (
							<SelectSearch
								disabled={false}
								list={customerOptions}
								label="Select Customer"
								getOptionLabel={(item) => item.name}
								getOptionValue={(item) => item.name}
								value={tab1Data.customer}
								onChange={(val) => {
									setSelectedCustomer(val);
									handleChange("customer", val);
								}}
								searchTerm={searchTerm}
								setSearchTerm={setSearchTerm}
								className={fieldErrors.customer ? "errorborder" : ""}
							/>
						)}
					</div>

					<div className="col-12" style={{ marginBottom: "12px" }}>
						{po_status !== "" && (
							<Date
								id="dueDate"
								label="Delivery Date"
								readOnly={false}
								value={tab1Data.dueDate ? true : false}
								onChange={(e) => handleChange("dueDate", e.target.value)}
								className={fieldErrors.dueDate ? "errorborder" : ""}
								style={{ height: "30px" }}
							/>
						)}
					</div>

					<div className="col-12" style={{ marginBottom: "12px" }}>
						{po_status !== "" ? (
							<Input
								id="billingType"
								label="Select Billing Type"
								value={tab1Data.billingType}
								readOnly={true}
								className={fieldErrors.billingType ? "errorborder" : ""}
								style={{ height: "30px" }}
							/>
						) : (
							<SelectSearch
								id="billingType"
								disabled={false}
								label="Select Billing Type"
								list={billingTypeList}
								getOptionLabel={(item) => item.name}
								getOptionValue={(item) => item.name}
								value={tab1Data.billingType}
								onChange={(val) => handleChange("billingType", val)}
								className={fieldErrors.billingType ? "errorborder" : ""}
							/>
						)}
					</div>

					<div className="col-12" style={{ marginBottom: "12px" }}>
						{po_status !== "" ? (
							<Input
								id="order_type"
								label="Select Order Type"
								value={tab1Data.order_type}
								readOnly={true}
								className={fieldErrors.order_type ? "errorborder" : ""}
								style={{ height: "30px" }}
							/>
						) : (
							<SelectSearch
								disabled={false}
								id="order_type"
								label="Select Order Type"
								list={orderTypeList}
								getOptionLabel={(item) => item.name}
								getOptionValue={(item) => item.name}
								value={tab1Data.order_type}
								onChange={(val) => handleChange("order_type", val)}
								className={fieldErrors.order_type ? "errorborder" : ""}
							/>
						)}
					</div>

					{/* </div> */}
				</div>
				<CollapsibleSection title="Accounting Dimensions">
					<div className="col-lg-12 mt-3 mb-3">
						<div className={cost_center.Error ? `mb-3 errorborder` : `mb-3`}>
							<SelectSearch
								list={cost_center.list}
								label="Cost Center"
								getOptionLabel={(item) => item.name}
								getOptionValue={(item) => item.name}
								value={cost_center.value || genaralData?.cost_center}
								onChange={(val) => cost_center.setvalue(val)}
							/>
						</div>
					</div>
					<div className="col-lg-12 mt-3 mb-3">
						<div className={project.Error ? `mb-3 errorborder` : `mb-3`}>
							<SelectSearch
								list={project.list}
								label="Project"
								getOptionLabel={(item) => item.name}
								getOptionValue={(item) => item.name}
								value={project.value || genaralData?.project}
								onChange={(val) => project.setvalue(val)}
							/>
						</div>
					</div>
				</CollapsibleSection>
				<CollapsibleSection title="Payment Terms">
					<div className="col-lg-12 mt-3 mb-3">
						<div className={pTerms.Error ? `mb-3 errorborder` : `mb-3`}>
							<SelectSearch
								list={pTerms.list}
								label="Payment Terms Template"
								getOptionLabel={(item) => item.name}
								getOptionValue={(item) => item.name}
								value={pTerms.value || genaralData?.payment_terms_template}
								onChange={(val) => pTerms.setpaymentterm(val)}
							/>
						</div>
					</div>
				</CollapsibleSection>
				<CollapsibleSection title="Currency and Price List">
					<div className="col-lg-12 mt-3 mb-3">
						<div className={currency.Error ? `mb-3 errorborder` : `mb-3`}>
							<SelectSearch
								list={currency.list}
								label="Currency"
								getOptionLabel={(item) => item.name}
								getOptionValue={(item) => item.name}
								value={currency.value || genaralData?.currency}
								onChange={(val) => currency.setvalue(val)}
							/>
						</div>
					</div>

					<div className="col-lg-12 mt-3 mb-3">
						<div className={price.Error ? `mb-3 errorborder` : `mb-3`}>
							<SelectSearch
								list={price.list}
								label="Price List"
								getOptionLabel={(item) => item.name}
								getOptionValue={(item) => item.name}
								value={price.value || genaralData?.selling_price_list}
								onChange={(val) => price.setvalue(val)}
							/>
						</div>
					</div>
				</CollapsibleSection>
				<CollapsibleSection title="Taxes and Charges">
					<div className="col-lg-12 mt-3 mb-3">
						<div className={taxandchanges.Error ? `mb-3 errorborder` : `mb-3`}>
							<SelectSearch
								list={taxandchanges.list}
								label="Taxes and Charges"
								getOptionLabel={(item) => item.name}
								getOptionValue={(item) => item.name}
								value={taxandchanges.value || genaralData?.taxes_and_charges}
								onChange={(val) => taxandchanges.setvalue(val)}
							/>
						</div>
					</div>
				</CollapsibleSection>
				<CollapsibleSection title="Terms & Conditions">
					<div className="col-lg-12 mt-1 mb-3">
						<div
							className={termandcondition.Error ? `mb-3 errorborder` : `mb-3`}
						>
							<SelectSearch
								list={termandcondition.list}
								label="Terms and Conditions"
								getOptionLabel={(item) => item.name}
								getOptionValue={(item) => item.name}
								value={
									termandcondition.termsandcondition || genaralData?.tc_name
								}
								onChange={(val) => termandcondition.settermsandcondition(val)}
							/>
						</div>
					</div>
				</CollapsibleSection>
				<div style={{ height: "28vh" }}>
					<div className="col-12">
						<div
							className="py-2 d-flex justify-content-between align-items-center"
							onClick={() => setShowActivity(!showActivity)}
						>
							<p className="firstcolor m-0">Activity</p>
							<GetIcon
								iconName={
									showActivity ? "MdKeyboardArrowUp" : "MdKeyboardArrowDown"
								}
								size={22}
							/>
						</div>

						{showActivity && (
							<VersionHistory
								doctype="Sales Order"
								docname={orderNo}
								activityboll={true}
							/>
						)}
					</div>
				</div>
			</div>
		);
}

export default Tab1;